import { render, staticRenderFns } from "./Betas.vue?vue&type=template&id=2e2e33e0&"
import script from "./Betas.vue?vue&type=script&lang=js&"
export * from "./Betas.vue?vue&type=script&lang=js&"
import style0 from "./Betas.vue?vue&type=style&index=0&id=2e2e33e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports